var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: "处理提醒",
        width: 650,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: _vm.labelCol,
              wrapperCol: _vm.wrapperCol,
              model: _vm.form,
            },
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "问题原因" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择问题原因",
                    dictCode: "emotional_type",
                  },
                  model: {
                    value: _vm.form.tagId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "tagId", $$v)
                    },
                    expression: "form.tagId",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "干预措施" } },
              [
                _c("j-dict-select-tag", {
                  attrs: {
                    placeholder: "请选择干预措施",
                    dictCode: "intervention",
                  },
                  model: {
                    value: _vm.form.interventionId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "interventionId", $$v)
                    },
                    expression: "form.interventionId",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "其他措施" } },
              [
                _c("a-textarea", {
                  attrs: { "auto-size": { minRows: 6, maxRows: 10 } },
                  model: {
                    value: _vm.form.comment,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "comment", $$v)
                    },
                    expression: "form.comment",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }